import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAudioSchemas } from '../../services/AudioSchemaService';
import { AudioSchemasResponse } from '../../types/AudioSchemas';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAudioSchemas(fleetId: string, query?: string): UseQueryResult<AudioSchemasResponse> {
  return useQuery(
    ['audio-schemas', fleetId, query],
    async (): Promise<AudioSchemasResponse> => getAudioSchemas(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      // refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetAudioSchemas;
